import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { DialogFooterComponent } from './components/dialog-footer/dialog-footer.component';
import { DialogBodyComponent } from './components/dialog-body/dialog-body.component';
import { DialogMainComponent, DialogRef } from './components/dialog-main/dialog-main.component';
import { DialogService } from './services/dialog.service';

@NgModule({
    imports: [
        TranslateModule.forChild(),
        CommonModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt- md',
                'gt-lg'
            ]
        }),
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        MatProgressBarModule
    ],
    declarations: [DialogHeaderComponent, DialogFooterComponent, DialogBodyComponent, DialogMainComponent],
    exports: [DialogHeaderComponent, DialogFooterComponent, DialogBodyComponent, DialogMainComponent],
    providers: [DialogRef, DialogService]
})
export class DialogModule {}
